
import React ,{useState , useEffect} from "react";
import { CommonCharts } from "../CommonCharts/CommonCharts";
import Commonrecords from "../Commonrecords/Commonrecords";
import { useDispatch, useSelector } from "react-redux";
import {clearCustomerSupportZoneList ,clearCustomerSupportZoneChart } from "../../../../../../../../Redux/Slice"


export default function Zonecontaintab({
      datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range

}) {
    const dashboardData = useSelector((state) => state.CustomerSupportZoneList.CustomerSupportZoneListData);
    const ChartResponse_API = useSelector((state) => state.CustomerSupportZoneChart.CustomerSupportZoneChartData);
    const state = useSelector((state) => state);
     const dispatch = useDispatch();
  const [search, setSearch] = useState("");
let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");




  useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                client:Client,
                               search:search,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
date:date,
                                        state:datas.state,
                                            region: datas.region,
                zone: datas.zone,

            }
         dispatch(clearCustomerSupportZoneList(payload))
    }
    },[datas  ,Client  ,PriorityValues , date ,search ,range])


   useEffect(()=>{
        if(state.ClientBranchIDs.SUBROLE == 3){
         const payload ={
                client:Client,
                priority:PriorityValues, 
      from_date: range[0],
      to_date: range[1],
      range: isValidRange,
              date:date,
                            state:datas.state,
                                            region: datas.region,
                zone: datas.zone,


              }
         dispatch(clearCustomerSupportZoneChart(payload))
    }
    },[datas  ,Client  ,PriorityValues ,date ,range ])



const Allissues = dashboardData.map((item) => ({
  id: item.client_id__zone_id__id,
  name: item.client_id__zone_id__zone_name,
  count: item.group_tickets,
}));


const ChartResponse = ChartResponse_API.map(item => ({
value: item.ticket_percentage != null
  ? parseFloat(item.ticket_percentage.toFixed(2))
  : 0,
  name: item.client_id__zone_id__zone_name.toLowerCase().replace(/\b\w/g, c => c.toUpperCase()) // Proper Case
}));

  return (
    <div className="chart-list-row_state">

  <div className="Chart_design">

        <CommonCharts title="Top 5 Issue Zone" data={ChartResponse} />
  </div>

<div className="Listed_datas">

  <Commonrecords allIssues={Allissues}  title={"Zones List"} 
    search={search} setSearch={setSearch}
       Table_names={"zone"}

  />

</div>
    </div>
  );
}
